import {OptionGroup, ProductOption} from "@/data/entities/option/index";

export const findOptionGroupById = (optionGroupId: number, list: OptionGroup[]): OptionGroup => {
    const result = list.find((value: OptionGroup) => value.id === optionGroupId);

    if (!result)
        throw new Error(`Option group ${optionGroupId} not found!`)

    return result;
}

export const findOptionById = (optionId: number, list: ProductOption[]): ProductOption => {
    const result = list.find((value: ProductOption) => value.id === optionId);

    if (!result)
        throw new Error(`Option ${optionId} not found!`)

    return result;
}